/**
 * SMB Contact Box Component
 * Works only with sticky variant (isSticky = true)
 * @version 1.0.0
 * @author Jiri Sivak <jiri.sivak@avast.com>
 * @requires avast.avm.cash
 * @requires <#snippet.smbCmp_contactBox#>
 */

(function() {
	'use strict';

    var $ = avm.require('cash');

    if (window.IntersectionObserver) {
        var headerWaypoint = document.querySelector(".header"),
            footerWaypoint = document.querySelector(".footer");

        var stickyContactBoxEl = $(".smb-contact-box--sticky"),
            stickyContactBoxVisibleClass = "smb-contact-box--visible";

        var isStickyContactBoxVisible = false; // Default state

        if (headerWaypoint || footerWaypoint) {
            var observer = new IntersectionObserver(function (entries) {
                var ratios = entries.map(function (entry) {
                    return entry.intersectionRatio;
                });
                isStickyContactBoxVisible = ratios.every(function (ratio) {
                    return ratio <= 0;
                });

                if (stickyContactBoxEl) {
                    if (isStickyContactBoxVisible) {
                        stickyContactBoxEl.addClass(stickyContactBoxVisibleClass);
                    } else {
                        stickyContactBoxEl.removeClass(stickyContactBoxVisibleClass);
                    }
                }
            }, { threshold: 0 });
            headerWaypoint && observer.observe(headerWaypoint);
            footerWaypoint && observer.observe(footerWaypoint);
        } else {
            // If there is no header and footer -- Show contact box by default
            if (isStickyContactBoxVisible && stickyContactBoxEl) {
                stickyContactBoxEl.addClass(stickyContactBoxVisibleClass);
            }
        }
    }
})();
